export default __webpack_public_path__ + "static/media/Slide10.655a4616.jpg";